import { Vector3 } from "three/src/math/Vector3";
import { PlanetClass } from "../../types/planetclass.enum";
import { Moon } from "./moon.model";

export class Planet {
  public readonly id!: number; // this is the solar system id!!
  private readonly _name!: string;
  public readonly orbit!: number;

  public readonly type!: PlanetClass;
  public readonly radius!: number;
  public readonly mass!: number;

  private _selected = false;

  private _moons: Array<Moon> = [];

  constructor(id: number, orbit: number, name: string, type: PlanetClass, radius: number, mass: number) {
    this.id = id;
    this._name = name;
    this.orbit = orbit;

    this.type = type;

    this.radius = radius;
    this.mass = mass;
  }

  public get name(): string {
    return this._name;
  }

  public get moons(): Array<Moon> {
    return this._moons;
  }

  public set moons(value: Array<Moon>) {
    this._moons = value;
  }

  public get selected(): boolean {
    return this._selected;
  }

  public set selected(value: boolean) {
    this._selected = value;
  }

  public select(): void {
    this._selected = true;
  }

  public deselect(): void {
    this._selected = false;
  }

  public toggle(): void {
    this._selected = !this._selected;
  }

  private get moonsJson(): string {
    return this._moons.map(moon => moon.toJson()).join(':');
  }

  public toJson(): string {
    return `${this.type}:${this.radius}:${this.mass}`;
  }
}
